/* eslint-disable */
import React, { Component } from 'react'
import BigModal from '../containers/BigModal'
import Select from 'react-select'
import API from 'API'
import ENDPOINTS from 'config/endpoints'
import FlowTable from 'components/basic/tables/FlowTable'
import LinkedInput from 'components/basic/inputs/LinkedInput'
var SearchWithResults = null
try {
  SearchWithResults = require('../../../projects/' + process.env.REACT_APP_PROJECT + '/components/core/search/SearchWithResults.js').default
} catch (e) {}

class ObjectPicker extends Component {
  constructor (props) {
    super(props)
    this.state = {
      modal: props.modal,
      results: [],
      system: {},
      ports: [],
      count: this.props.count || 10,
      totalResults: 0,
      activePage: 1,
      filter: '',
      labels: [],
      label: null
    }
  }
  componentDidMount () {
    this.init()
  }
  componentWillReceiveProps (props) {
    if (this.state.modal === props.modal) return
    this.setState({modal: props.modal})
  }
  async init () {
    let params = {
      sorting: true,
      'sorting.by': 'name',
      'sorting.order': 'ASC'
    }

    let components = await API.list(ENDPOINTS.ADMIN.SYSTEM, { parameters: params })
    if (!this.props.components) return this.setState({components: components.data})
    let filteredComponents = components.data.filter((component) => this.props.components.includes(component.component))

    if (filteredComponents.length === 1) {
      let systems = await API.make(filteredComponents[0].component + '/schema')
      this.getLabels(filteredComponents[0].component)
      if (!this.props.systems) {
        return this.setState({components: filteredComponents, component: filteredComponents[0].component, systems: systems.data})
      } else {
        let filteredSystems = systems.data.filter((system) => this.props.systems.includes(system.name.toLowerCase()))
        if (filteredSystems.length === 1) {
          this.setState({ components: filteredComponents, component: filteredComponents[0].component, systems: filteredSystems, system: filteredSystems[0].name })
        } else {
          this.setState({ components: filteredComponents, component: filteredComponents[0].component, systems: filteredSystems })
        }
      }
    } else {
      this.setState({ components: filteredComponents })
    }
  }
  closeModal () {
    this.setState({modal: false, system: {}, component: null, result: [], type: null, ports: []})
    this.props.closeModal()
  }
  async selectNamespace (component) {
    if (!component) return this.setState({component: component, systems: []})
    let systems = await API.make(component + '/schema')
    this.getLabels(component)
    if (!this.props.systems) return this.setState({component: component, systems: systems.data})
    this.setState({component: component, systems: systems.data.filter((system) => this.props.systems.includes(system.name.toLowerCase()))})
  }
  async selectObject (object) {
    this.setState({system: object})
  }
  async selectLabel (label) {
    if (this.state.system === 'Port' && this.state.device) {
      this.setState({label: label}, this.setPorts)
    } else {
      this.setState({label: label})
    }
  }
  async setDevice (device) {
    this.setState({device: device, label: null}, this.setPorts)
  }

  async setPorts () {
    var params = Object.assign(
      {},
      {
        pagination: true,
        'pagination.size': this.state.count,
        'pagination.from': (this.state.count * (this.state.activePage - 1)),
        sorting: true,
        'sorting.by': 'ports.number',
        'sorting.order': 'ASC'
      },
      this.state.filter ? {
        'condition': true,
        'condition.values': {
          'items': [{
            'key': 'ports.name',
            'value': this.state.filter,
            'operator': 'CONTAINS'
          }]
        }
      } : {})
    if (this.state.label !== null) {
      params['label'] = this.state.label
    }
    let ports = await API.list(ENDPOINTS.INVENTORY.DEVICE_PORT,
      {
        objectid: this.state.device.id,
        parameters: params
      })
    this.setState({ports: ports.data ? ports.data : [], totalResults: ports.count})
  }

  concatString (title, description) {
    if ((title.length + description.length) > 104) {
      return description.substr(0, (100 - title.length)) + ' ...'
    }
    return description
  }

  filterTimeout () {
    clearTimeout(this.state.timer)
    this.state.timer = setTimeout(() => this.setPorts(), 300)
  }
  processLabels (labels) {
    if (labels !== undefined && labels.length > 0) {
      labels = labels.sort()
      return labels.map(label => <p style={{'display': 'inline', 'margin-right': '5px'}} className={'status-label status-label-success'}>{label}</p>)
    }
    return ''
  }
  setValue (result) {
    this.props.select({
      id: result.id,
      system: result.system,
      type: result.type,
      title: result.title,
      description: result.description
    })
    this.closeModal()
  }

  async getLabels (component) {
    if (component !== undefined) {
      let labels = await API.list(component + '/label',
        {
          parameters: {
            'sorting': true,
            'sorting.by': 'name',
            'sorting.order': 'ASC'
          }
        })
      this.setState({label: null, labels: labels['data']})
    } else {
      this.setState({label: null, labels: []})
    }
  }
  handleChange (e) {
    this.setState({filter: e.target.value, activePage: 1}, this.filterTimeout)
  }
  render () {
    return (
      <BigModal noOverflow isOpen={this.state.modal} close={() => this.closeModal()} title={this.props.title ? this.props.title : 'Object Picker'}>
        <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-4'>
              <label>Component</label>
              <Select
                value={this.state.component}
                options={this.state.components}
                labelKey='component'
                valueKey='component'
                resetValue={{}}
                onChange={(e) => this.selectNamespace(e.component)}
              />
            </div>
            {this.state.components &&
              <div className='col-md-4'>
                <label>Type</label>
                <Select
                  value={this.state.system}
                  options={this.state.systems}
                  labelKey='name'
                  disabled={!this.state.systems}
                  valueKey='name'
                  resetValue={{}}
                  onChange={(e) => this.selectObject(e.name)}
                />
              </div>
            }
            {this.state.labels &&
              <div className='col-md-4'>
                <label>Label</label>
                <Select
                  value={this.state.label}
                  options={this.state.labels}
                  labelKey='name'
                  valueKey='name'
                  resetValue={{}}
                  onChange={(e) => this.selectLabel(e.name)}
                />
              </div>
            }
          </div>
          {this.state.system && Object.keys(this.state.system).length > 0 &&
            <div className='row'>
              {this.state.system === 'Port' && !this.state.device &&
                <div className='col-md-12'>
                  <label>Search for a device</label>
                  <SearchWithResults namespace={ENDPOINTS.INVENTORY.DEVICE} label={this.state.label} callback={(result) => this.setDevice(result)} />
                </div>
              }
              {this.state.system === 'Port' && this.state.device &&
                <div className='col-md-12 objectpicker-results-field'>
                  <LinkedInput
                    type='text'
                    context={this}
                    path='filter'
                    onChange={(e) => this.handleChange(e)}
                    placeholder='Search' />
                  <FlowTable onPageChange={e => this.setState({activePage: e}, this.setPorts)} totalResults={this.state.totalResults} activePage={this.state.activePage} count={this.state.count} className='objectpicker-table' emptyIcon='fa-search' emptyText='No Results' data={this.state.ports.map(port => [
                    <a className='table-link' onClick={() => this.props.select({id: port.id, system: 'inventory', type: 'port', 'title': port.name, 'description': this.state.device.title + ' port ' + port.name}) && this.closeModal()}><i className='fa fa-fw fa-plus' /></a>,
                    port.name,
                    this.concatString(port.name || '', port.description || ''),
                    this.processLabels(port.labels)
                  ])}>
                    <tr>
                      <th className='buttons' />
                      <th>Name</th>
                      <th>Description</th>
                      <th>Label(s)</th>
                    </tr>
                  </FlowTable>
                </div>
              }
              {this.state.system !== 'Port' &&
              <div className='col-md-12 objectpicker-results-field'>
                <SearchWithResults
                  namespace={this.state.component + '/' + this.state.system}
                  label={this.state.label}
                  callback={(result) => this.setValue(result)}
                />

              </div>
              }
            </div>
          }
        </div>
      </BigModal>
    )
  }
}

export default ObjectPicker



// WEBPACK FOOTER //
// ./src/components/basic/misc/ObjectPicker.js